// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-35XkP","segmentTab":"segmentTab-2V6rf","active":"active-1ea92","title":"title-3n-h1"};